import { useMemo } from "react";
import { useInventoryBootstrap } from "../../../../contexts/InventoryBootstrapContext";
import { applyAllEntitiesFilters } from "./logics/allEntitiesFiltersLogic";
import { applyAppFilters } from "./logics/appFiltersLogic";
import { applyDatastoreFilters } from "./logics/datastoreFiltersLogic";
import { applyHostFilters } from "./logics/hostFiltersLogic";
import { applyNHIFilters } from "./logics/nhiFiltersLogic";
import { applyServerFilters } from "./logics/serverFiltersLogic";
import { applyServiceNowFilters } from "./logics/serviceNowFiltersLogic";
import { applySharedFilters } from "./logics/sharedFiltersLogic";
import { applyUserFilters } from "./logics/userFiltersLogic";

export default function useFilterEntities(
  fetchedEntities,
  appliedFilters,
  filterAndOrLogics,
  assets
) {
  const { favorites: fetchedFavoriteEntities, tags: allCustomTags } =
    useInventoryBootstrap();

  const filteredEntities = useMemo(() => {
    if (!Array.isArray(fetchedEntities)) {
      return [];
    }

    const filteredEntities = [...fetchedEntities];

    applySharedFilters(
      filteredEntities,
      appliedFilters,
      filterAndOrLogics,
      assets,
      fetchedFavoriteEntities,
      allCustomTags
    );
    applyAllEntitiesFilters(filteredEntities, appliedFilters);
    applyHostFilters(filteredEntities, appliedFilters, filterAndOrLogics);
    applyUserFilters(filteredEntities, appliedFilters, filterAndOrLogics);
    applyServerFilters(filteredEntities, appliedFilters);
    applyDatastoreFilters(filteredEntities, appliedFilters, filterAndOrLogics);
    applyNHIFilters(filteredEntities, appliedFilters, filterAndOrLogics);
    applyAppFilters(filteredEntities, appliedFilters);
    applyServiceNowFilters(filteredEntities, appliedFilters);

    return filteredEntities;
  }, [fetchedEntities, appliedFilters, filterAndOrLogics]);

  return filteredEntities;
}
